import _                         from 'underscore';
import React, { FC, useContext } from 'react';
import { useQuery }              from '@apollo/react-hooks';

import { CorvalHireType, CorvalProject, CorvalProjectVersionHireType, Uuid } from '@src/types';

import { formatOption, IFormatOptionValue }     from '@src/util';
import { useProjectTermDictionary }             from '@src/hooks';
import { DecisionEngineQueries }                from '@src/queries';
import { queriesHaveData, queriesLoading }      from '@src/store/_apolloUtil';
import { ProjectContext }                       from "@src/views/pages/projects/ProjectIndexPage";
import { ProjectQueries }                       from '@src/queries/ProjectQueries';
import { QueriedSelectFieldProps, SelectField } from '@src/views/components/forms/formik/SelectField';


interface ProjectVersionHireTypeDropdownProps extends QueriedSelectFieldProps {
    projectId?: Uuid,
    projectVersionId?: Uuid,
    loading?: boolean,
    formatOptions?: object,
}

const defaultProps: ProjectVersionHireTypeDropdownProps = {
    loading:       false,
    formatOptions: {}
};

const ProjectVersionHireTypeDropdown: FC<ProjectVersionHireTypeDropdownProps> = ( _props ) => {

    let { projectId: currentProjectId, projectVersionId: currentProjectVersionId } = useContext( ProjectContext ),
        { formatOptions, ...props }                                                = _props;

    const projectId                            = props.projectId ?? currentProjectId ?? undefined,
          projectVersionId                     = props.projectVersionId ?? currentProjectVersionId ?? undefined;

    // Need to get all project version hire types to know
    // how they are currently configured for business function grouping
    let getProjectVersionHireTypesReq = useQuery<{ projects: CorvalProject[] }>(
        ProjectQueries.queries.GET_PROJECT_HIRE_TYPES(
            ProjectQueries.fragments.PROJECT_HIRE_TYPES.QUERY_RETURN( projectVersionId )
        ), {
            variables:   { projectId: projectId },
            fetchPolicy: 'cache-and-network',
            skip:        !projectId || !projectVersionId,
        } );

    let isLoading = ( props.loading || queriesLoading( [ getProjectVersionHireTypesReq ] ) );

    let options = [] as IFormatOptionValue[];

    if( queriesHaveData( [ getProjectVersionHireTypesReq ] ) ){

        const { projectVersions } = _.first( getProjectVersionHireTypesReq.data.projects ),
              { hireTypes }       = _.first( projectVersions );

        // Group by business function, sort by name
        options = _.chain( hireTypes )
                   .sortBy(  v => v.businessFunction.name )
                   .groupBy( v => v.businessFunction.name )
                   .values().map( set => _.sortBy( set, 'name' ) )
                   .flatten().map( ( h: CorvalProjectVersionHireType ) =>
                        formatOption( h.hireTypeId, h.name, { group: h.businessFunction.name, ...formatOptions } ) )
                   .value();
    }

    return (
        <SelectField
            useGroupNames={ true }
            { ...props }
            search
            loading={ isLoading }
            options={ options }
        />
    );
};

ProjectVersionHireTypeDropdown.defaultProps = defaultProps;

export { ProjectVersionHireTypeDropdown };
